"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abstractmessage_1 = require("./abstractmessage");

var Close =
/*#__PURE__*/
function (_abstractmessage_1$Ab) {
  _inherits(Close, _abstractmessage_1$Ab);

  function Close() {
    var _this;

    _classCallCheck(this, Close);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Close).call(this));
    _this.method = 'close';
    return _this;
  }

  return Close;
}(abstractmessage_1.AbstractMessage);

exports.Close = Close;